<div id="login">
  <header class="login-header">
    <h1 class="header-text">Invoice2go internal login</h1>
  </header>

  <div class="form-wrapper">
    <app-form-master [form]="form" (submitForm)="login()">
      <app-input-field
        label="Username"
        fieldId="username_field"
        e2eId="login-username"
        placeholder="Enter your beta username..."
        [fieldControl]="form.get('username')"
      >
      </app-input-field>

      <app-input-field
        label="Password"
        fieldId="password_field"
        e2eId="login-password"
        placeholder="Enter your beta password..."
        type="password"
        [fieldControl]="form.get('password')"
      >
      </app-input-field>

      <span *ngIf="errorMessage" class="error-message">
        {{ errorMessage }}
      </span>

      <button
        type="button"
        i2gButton
        buttonStyle="emphasis"
        class="login-action"
        data-e2e-id="login-submit"
        [disabled]="loggingIn"
        (click)="login()"
      >
        Log in
      </button>
    </app-form-master>
  </div>
</div>
